import type { MouseEvent, ReactNode } from "react";

type Props = {
  icon: ReactNode;
  label: string;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
};

export type MenuItemProps = Props;

export default function MenuItem({ icon, label, onClick }: Props) {
  return (
    <div
      className="flex cursor-pointer items-center gap-2 border-0 border-solid border-aubergine-perl-800 px-6 py-3 text-aubergine-perl-600 hover:border-r-2 hover:bg-aubergine-perl-500 hover:text-dr-white-600 [&>p]:hover:text-dr-white-600 [&>span]:hover:text-dr-white-600 [&>svg]:hover:stroke-dr-white-600"
      onClick={onClick}
    >
      {icon}
      <p className="my-0 px-1 text-sm font-normal text-black">{label}</p>
    </div>
  );
}
